import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default class Checkbox extends Component {
  static propTypes = {
    checked: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.object,
    id: PropTypes.string.isRequired,
  };

  static defaultProps = {
    checked: false,
    className: {},
  };

  handleChange = (e) => {
    // this call doesn't work properly because React still handles the click on the parent before
    // the checkbox/label click
    e.stopPropagation();
    this.props.onChange(e.target.checked);
  };

  render() {
    const { checked, id, className } = this.props;

    const finalClassName = classnames({
      'checkbox-container': true,
      'flex-shrink-0': true,
      ...className,
    });

    return (
      <div className={finalClassName}>
        <input
          type="checkbox"
          className=""
          checked={checked}
          id={id}
          onChange={this.handleChange}
        />
        <label className="block" htmlFor={id} />
      </div>
    );
  }
}
